var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentWhitepaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190.5mm",
    height: "231.24583mm",
    viewBox: "0 0 190.5 231.24583",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 720,
    height: 874,
    id: "rect824"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 733.755,
    y1: 732.88898,
    x2: -13.7545,
    y2: 141.11099,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill1",
    gradientTransform: "matrix(0.26458333,0,0,0.26458333,118.21875,94.633094)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6C1863",
    id: "stop827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9D2791",
    id: "stop829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB31AD",
    id: "stop831"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 112,
    width: 93,
    height: 94,
    id: "rect834"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 112,
    width: 93,
    height: 94,
    id: "rect837"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 112,
    width: 93,
    height: 94,
    id: "rect840"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-118.21875,-94.633094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 118.21875,99.423957 c 0,-2.645918 2.14494,-4.790863 4.79086,-4.790863 h 56.035 c 2.64583,0 4.79081,2.144945 4.79081,4.790863 v 47.568323 c 0,2.64584 -2.14498,4.79081 -4.79081,4.79081 h -56.035 c -2.64592,0 -4.79086,-2.14497 -4.79086,-4.79081 z",
    fill: "#382463",
    fillRule: "evenodd",
    id: "path845",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 258.7125,270.53973 c 0,-2.3151 1.87695,-4.19205 4.19206,-4.19205 h 41.62213 c 2.3151,0 4.19206,1.87695 4.19206,4.19205 v 51.14714 c 0,2.3151 -1.87696,4.19205 -4.19206,4.19205 h -41.62213 c -2.31511,0 -4.19206,-1.87695 -4.19206,-4.19205 z",
    fill: "#382463",
    fillRule: "evenodd",
    id: "path847",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 133.03542,112.19513 c 0,-1.95461 1.58451,-3.53912 3.53912,-3.53912 h 153.78847 c 1.95448,0 3.53907,1.58451 3.53907,3.53912 v 196.12181 c 0,1.95448 -1.58459,3.53907 -3.53907,3.53907 H 136.57454 c -1.95461,0 -3.53912,-1.58459 -3.53912,-3.53907 z",
    fill: "url(#fill1)",
    fillRule: "evenodd",
    id: "path849",
    style: {
      fill: "url(#fill1)",
      strokeWidth: 0.264583
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    id: "g863",
    transform: "matrix(0.26458333,0,0,0.26458333,118.21875,94.633094)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    id: "g861"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    id: "g859"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.6047,33.3544 C 72.0389,22.5441 62.1673,14.8961 50.5591,13.1758 c -0.24,-0.0361 -0.4823,-0.0543 -0.7249,-0.0543 -2.7074,0.0033 -4.9012,2.1973 -4.9047,4.9047 v 7.9731 c 0,2.2919 1.8578,4.1497 4.1497,4.1497 2.2919,0 4.1497,-1.8578 4.1497,-4.1497 v -3.3282 c 10e-4,-0.1558 0.126,-0.2826 0.2818,-0.2859 0.0294,0 0.0586,0.0047 0.0866,0.0141 13.28,4.4068 20.4733,18.7448 16.0665,32.0247 -3.0928,9.3202 -11.2929,16.0138 -21.0437,17.1773 -2.2784,0.2467 -3.9255,2.2939 -3.6787,4.5723 0.2289,2.1135 2.0181,3.7124 4.1438,3.7029 0.1641,6e-4 0.3282,-0.0088 0.4913,-0.0282 C 68.0289,77.6555 81.21,60.9191 79.0172,42.4667 78.6447,39.331 77.8325,36.2636 76.6047,33.3544 Z",
    fill: "#ffffff",
    transform: "matrix(1,0,0,1.01075,148,112)",
    id: "path851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89.396,28.5101 C 79.4499,4.82098 52.1833,-6.31995 28.4942,3.62611 17.3385,8.30988 8.44659,17.1556 3.7047,28.2866 -6.28299,51.9521 4.80513,79.2334 28.4706,89.2212 52.0353,99.1661 79.2083,88.2175 89.2953,64.7134 94.2054,53.1522 94.2417,40.0985 89.396,28.5101 Z M 83.7846,46.5966 C 83.7054,67.1249 66.9999,83.702 46.4716,83.6229 25.9436,83.5438 9.36636,66.8382 9.44551,46.3099 9.52468,25.7819 26.2303,9.2046 46.7583,9.28377 c 14.9229,0.05757 28.3643,9.03413 34.135,22.79613 1.928,4.5956 2.9086,9.5331 2.8832,14.5167 z",
    fill: "#ffffff",
    transform: "matrix(1,0,0,1.01075,148,112)",
    id: "path853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.0537,38.6416 C 61.8304,31.0089 54.3485,26.0495 46.0631,26.0537 v 0 c -11.3855,8e-4 -20.6146,9.2315 -20.6138,20.617 8e-4,9.8143 6.9201,18.2672 16.5406,20.2072 1.856,0.3591 3.6516,-0.8541 4.0108,-2.7101 0.0418,-0.2163 0.0628,-0.4361 0.0624,-0.6564 v -0.0886 c -0.0075,-1.629 -1.1622,-3.027 -2.7604,-3.3423 -7.4148,-1.482 -12.2243,-8.6943 -10.7422,-16.1092 1.2849,-6.4288 6.9467,-11.0444 13.5026,-11.0075 v 0 c 6.5009,0.0016 12.1063,4.57 13.4195,10.9369 0.3122,1.5984 1.7075,2.7553 3.3362,2.7664 h 0.0825 c 1.8904,0.0032 3.4255,-1.5264 3.4289,-3.4168 4e-4,-0.2202 -0.0205,-0.4401 -0.0624,-0.6563 -0.2696,-1.3553 -0.6765,-2.6795 -1.2141,-3.9524 z",
    fill: "#ffffff",
    transform: "matrix(1,0,0,1.01075,148,112)",
    id: "path855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.6242,50.9054 c -2.4337,-0.3725 -4.1044,-2.6473 -3.7321,-5.0809 0.3572,-2.3324 2.4698,-3.9826 4.8193,-3.7641 0.324,0.0298 0.6439,0.094 0.9544,0.1913 0.2013,0.0674 0.3098,0.2855 0.2424,0.4868 -0.0256,0.0763 -0.0745,0.1426 -0.1397,0.1897 l -0.7208,0.5255 c -1.1596,0.8474 -1.4129,2.4743 -0.5658,3.6342 v 0 c 0.8432,1.1575 2.4638,1.4151 3.6241,0.5759 l 2.9698,-2.1443 c 1.6001,-1.1555 1.9605,-3.3894 0.805,-4.9897 -0.0461,-0.0638 -0.0942,-0.1262 -0.1446,-0.1868 -2.0847,-2.5158 -5.2991,-3.808 -8.5449,-3.4349 -3.2875,0.334 -6.1581,2.3698 -7.5604,5.3617 -2.8631,6.1611 1.0369,12.7993 7.202,13.7617 1.2795,0.2006 2.5862,0.1396 3.8416,-0.1792 1.3583,-0.3529 2.1731,-1.7402 1.8199,-3.0984 -0.0809,-0.3113 -0.2202,-0.6046 -0.4105,-0.864 l -0.0644,-0.0886 c -0.6202,-0.8331 -1.6798,-1.2124 -2.688,-0.9624 -0.5595,0.1323 -1.1393,0.1549 -1.7073,0.0665 z",
    fill: "#ffffff",
    transform: "matrix(1,0,0,1.01075,148,112)",
    id: "path857"
  }))))), /*#__PURE__*/React.createElement("g", {
    "aria-label": "EduBits",
    id: "text865",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 193.84248,132.4262 v 2.40453 h 3.87772 v 2.23519 h -3.87772 v 2.60773 h 4.38572 v 2.31987 h -7.28132 v -11.88718 h 7.28132 v 2.31986 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 199.53204,137.25219 q 0,-1.45626 0.54187,-2.55693 0.55879,-1.10066 1.50706,-1.69333 0.94826,-0.59266 2.11666,-0.59266 0.93133,0 1.69333,0.38946 0.77893,0.38947 1.2192,1.04987 v -4.38573 h 2.89559 v 12.53065 h -2.89559 v -1.35467 q -0.4064,0.67733 -1.1684,1.08373 -0.74506,0.4064 -1.74413,0.4064 -1.1684,0 -2.11666,-0.59266 -0.94827,-0.6096 -1.50706,-1.71027 -0.54187,-1.1176 -0.54187,-2.57386 z m 7.07812,0.0169 q 0,-1.08373 -0.6096,-1.71026 -0.59266,-0.62653 -1.45626,-0.62653 -0.8636,0 -1.4732,0.62653 -0.59267,0.6096 -0.59267,1.69333 0,1.08373 0.59267,1.7272 0.6096,0.62653 1.4732,0.62653 0.8636,0 1.45626,-0.62653 0.6096,-0.62653 0.6096,-1.71027 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 220.93571,132.54473 v 9.44879 h -2.89559 v -1.28694 q -0.44027,0.62654 -1.20226,1.016 -0.74507,0.37253 -1.65947,0.37253 -1.08373,0 -1.91346,-0.47413 -0.82973,-0.49106 -1.28693,-1.40546 -0.4572,-0.9144 -0.4572,-2.15053 v -5.52026 h 2.87866 v 5.13079 q 0,0.94827 0.49107,1.4732 0.49106,0.52493 1.32079,0.52493 0.84667,0 1.33773,-0.52493 0.49107,-0.52493 0.49107,-1.4732 v -5.13079 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 230.21516,135.89753 q 1.03293,0.22013 1.65946,1.03293 0.62654,0.79586 0.62654,1.82879 0,1.49014 -1.04987,2.37067 -1.03293,0.8636 -2.89559,0.8636 h -5.53719 v -11.88718 h 5.35092 q 1.81186,0 2.82786,0.82973 1.03293,0.82973 1.03293,2.25213 0,1.04986 -0.5588,1.74413 -0.54186,0.69426 -1.45626,0.9652 z m -4.30106,-0.98213 h 1.89653 q 0.7112,0 1.08373,-0.3048 0.38947,-0.32174 0.38947,-0.93134 0,-0.60959 -0.38947,-0.93133 -0.37253,-0.32173 -1.08373,-0.32173 h -1.89653 z m 2.1336,4.74132 q 0.72813,0 1.1176,-0.32173 0.40639,-0.33867 0.40639,-0.9652 0,-0.62653 -0.42333,-0.98213 -0.4064,-0.3556 -1.13453,-0.3556 h -2.09973 v 2.62466 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 235.63379,131.5626 q -0.762,0 -1.25306,-0.44026 -0.47414,-0.4572 -0.47414,-1.1176 0,-0.67733 0.47414,-1.1176 0.49106,-0.4572 1.25306,-0.4572 0.74507,0 1.2192,0.4572 0.49106,0.44027 0.49106,1.1176 0,0.6604 -0.49106,1.1176 -0.47413,0.44026 -1.2192,0.44026 z m 1.43933,0.98213 v 9.44879 h -2.89559 v -9.44879 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 244.43908,139.53819 v 2.45533 h -1.4732 q -1.5748,0 -2.45533,-0.762 -0.88053,-0.77894 -0.88053,-2.52307 v -3.75919 h -1.15147 v -2.40453 h 1.15147 v -2.30293 h 2.89559 v 2.30293 h 1.89653 v 2.40453 h -1.89653 v 3.79306 q 0,0.42333 0.2032,0.6096 0.2032,0.18627 0.67733,0.18627 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 249.89157,142.12898 q -1.23613,0 -2.20133,-0.42333 -0.9652,-0.42333 -1.524,-1.15147 -0.5588,-0.74506 -0.62653,-1.65946 h 2.86173 q 0.0508,0.49107 0.4572,0.79587 0.4064,0.3048 0.99906,0.3048 0.54187,0 0.82973,-0.2032 0.3048,-0.22014 0.3048,-0.5588 0,-0.4064 -0.42333,-0.59267 -0.42333,-0.2032 -1.3716,-0.44026 -1.01599,-0.23707 -1.69333,-0.49107 -0.67733,-0.27093 -1.16839,-0.82973 -0.49107,-0.57573 -0.49107,-1.54093 0,-0.8128 0.44027,-1.4732 0.45719,-0.67733 1.32079,-1.0668 0.88053,-0.38946 2.0828,-0.38946 1.778,0 2.79399,0.88053 1.03293,0.88053 1.18533,2.33679 h -2.67546 q -0.0677,-0.49106 -0.44026,-0.77893 -0.3556,-0.28786 -0.94827,-0.28786 -0.508,0 -0.77893,0.2032 -0.27093,0.18626 -0.27093,0.52493 0,0.4064 0.42333,0.6096 0.44027,0.2032 1.35466,0.4064 1.04987,0.27093 1.71027,0.54186 0.6604,0.254 1.15146,0.84667 0.508,0.57573 0.52493,1.55786 0,0.82973 -0.47413,1.49013 -0.4572,0.64347 -1.33773,1.016 -0.8636,0.37253 -2.01506,0.37253 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path932"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 146.13229,161.1758 H 280.92162",
    stroke: "#ffffff",
    strokeWidth: 0.705556,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    id: "path867"
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "EduBitsWhite Paper",
    id: "text871",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 185.13426,185.87203 v 2.40453 h 3.87772 v 2.2352 h -3.87772 v 2.60772 h 4.38572 v 2.31987 h -7.28132 v -11.88718 h 7.28132 v 2.31986 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 190.82382,190.69802 q 0,-1.45626 0.54186,-2.55693 0.5588,-1.10066 1.50707,-1.69333 0.94826,-0.59266 2.11666,-0.59266 0.93133,0 1.69333,0.38946 0.77893,0.38947 1.2192,1.04987 v -4.38573 h 2.89559 v 12.53065 h -2.89559 v -1.35467 q -0.4064,0.67733 -1.1684,1.08373 -0.74506,0.4064 -1.74413,0.4064 -1.1684,0 -2.11666,-0.59266 -0.94827,-0.6096 -1.50707,-1.71027 -0.54186,-1.11759 -0.54186,-2.57386 z m 7.07812,0.0169 q 0,-1.08374 -0.6096,-1.71027 -0.59267,-0.62653 -1.45626,-0.62653 -0.8636,0 -1.4732,0.62653 -0.59267,0.6096 -0.59267,1.69333 0,1.08373 0.59267,1.7272 0.6096,0.62653 1.4732,0.62653 0.86359,0 1.45626,-0.62653 0.6096,-0.62653 0.6096,-1.71026 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 212.22749,185.99056 v 9.44879 h -2.89559 v -1.28693 q -0.44027,0.62653 -1.20227,1.01599 -0.74506,0.37254 -1.65946,0.37254 -1.08373,0 -1.91346,-0.47414 -0.82973,-0.49106 -1.28693,-1.40546 -0.4572,-0.9144 -0.4572,-2.15053 v -5.52026 h 2.87866 v 5.13079 q 0,0.94827 0.49106,1.4732 0.49107,0.52493 1.3208,0.52493 0.84667,0 1.33773,-0.52493 0.49107,-0.52493 0.49107,-1.4732 v -5.13079 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 221.50694,189.34336 q 1.03293,0.22013 1.65946,1.03293 0.62653,0.79586 0.62653,1.8288 0,1.49013 -1.04986,2.37066 -1.03293,0.8636 -2.89559,0.8636 h -5.53719 v -11.88718 h 5.35092 q 1.81186,0 2.82786,0.82973 1.03293,0.82973 1.03293,2.25213 0,1.04986 -0.5588,1.74413 -0.54186,0.69427 -1.45626,0.9652 z m -4.30106,-0.98213 h 1.89653 q 0.7112,0 1.08373,-0.3048 0.38947,-0.32174 0.38947,-0.93133 0,-0.6096 -0.38947,-0.93134 -0.37253,-0.32173 -1.08373,-0.32173 h -1.89653 z m 2.1336,4.74132 q 0.72813,0 1.11759,-0.32173 0.4064,-0.33867 0.4064,-0.9652 0,-0.62653 -0.42333,-0.98213 -0.4064,-0.3556 -1.13453,-0.3556 h -2.09973 v 2.62466 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 226.92557,185.00843 q -0.762,0 -1.25306,-0.44026 -0.47414,-0.4572 -0.47414,-1.1176 0,-0.67733 0.47414,-1.1176 0.49106,-0.4572 1.25306,-0.4572 0.74506,0 1.2192,0.4572 0.49106,0.44027 0.49106,1.1176 0,0.6604 -0.49106,1.1176 -0.47414,0.44026 -1.2192,0.44026 z m 1.43933,0.98213 v 9.44879 h -2.89559 v -9.44879 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 235.73085,192.98402 v 2.45533 h -1.47319 q -1.5748,0 -2.45533,-0.762 -0.88053,-0.77893 -0.88053,-2.52306 v -3.7592 h -1.15147 v -2.40453 h 1.15147 v -2.30292 h 2.89559 v 2.30292 h 1.89653 v 2.40453 h -1.89653 v 3.79306 q 0,0.42334 0.2032,0.6096 0.2032,0.18627 0.67733,0.18627 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 241.18335,195.57481 q -1.23613,0 -2.20133,-0.42333 -0.9652,-0.42333 -1.524,-1.15146 -0.5588,-0.74507 -0.62653,-1.65947 h 2.86173 q 0.0508,0.49107 0.4572,0.79587 0.40639,0.3048 0.99906,0.3048 0.54187,0 0.82973,-0.2032 0.3048,-0.22014 0.3048,-0.5588 0,-0.4064 -0.42333,-0.59267 -0.42333,-0.2032 -1.3716,-0.44026 -1.016,-0.23707 -1.69333,-0.49107 -0.67733,-0.27093 -1.1684,-0.82973 -0.49106,-0.57573 -0.49106,-1.54093 0,-0.8128 0.44026,-1.4732 0.4572,-0.67733 1.3208,-1.0668 0.88053,-0.38946 2.0828,-0.38946 1.77799,0 2.79399,0.88053 1.03293,0.88053 1.18533,2.3368 h -2.67546 q -0.0677,-0.49107 -0.44026,-0.77894 -0.3556,-0.28786 -0.94827,-0.28786 -0.508,0 -0.77893,0.2032 -0.27093,0.18626 -0.27093,0.52493 0,0.4064 0.42333,0.6096 0.44026,0.2032 1.35466,0.4064 1.04987,0.27093 1.71027,0.54186 0.66039,0.254 1.15146,0.84667 0.508,0.57573 0.52493,1.55786 0,0.82973 -0.47413,1.49013 -0.4572,0.64347 -1.33773,1.016 -0.8636,0.37253 -2.01506,0.37253 z",
    style: {
      fontWeight: 700,
      fontSize: "16.9333px",
      fontFamily: "Poppins, Poppins_MSFontService, sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    id: "path947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 177.67297,203.92508 -3.0988,11.88718 h -3.50519 l -1.89653,-7.82319 -1.96426,7.82319 h -3.5052 l -3.01412,-11.88718 h 3.09879 l 1.71026,8.65292 2.11667,-8.65292 h 3.18346 l 2.03199,8.65292 1.7272,-8.65292 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 184.93732,206.26187 q 1.6256,0 2.60773,1.08374 0.98213,1.06679 0.98213,2.94639 v 5.52026 h -2.87866 v -5.13079 q 0,-0.94827 -0.49107,-1.4732 -0.49106,-0.52493 -1.32079,-0.52493 -0.82974,0 -1.3208,0.52493 -0.49107,0.52493 -0.49107,1.4732 v 5.13079 h -2.89559 v -12.53065 h 2.89559 v 4.35186 q 0.44027,-0.62653 1.20227,-0.99906 0.762,-0.37254 1.71026,-0.37254 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 191.9985,205.38134 q -0.762,0 -1.25306,-0.44026 -0.47413,-0.4572 -0.47413,-1.1176 0,-0.67733 0.47413,-1.1176 0.49106,-0.4572 1.25306,-0.4572 0.74507,0 1.2192,0.4572 0.49107,0.44027 0.49107,1.1176 0,0.6604 -0.49107,1.1176 -0.47413,0.44026 -1.2192,0.44026 z m 1.43933,0.98213 v 9.44879 h -2.89559 v -9.44879 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 200.80379,213.35693 v 2.45533 h -1.4732 q -1.5748,0 -2.45533,-0.762 -0.88053,-0.77893 -0.88053,-2.52306 v -3.7592 h -1.15146 v -2.40453 h 1.15146 v -2.30292 h 2.8956 v 2.30292 h 1.89652 v 2.40453 h -1.89652 v 3.79306 q 0,0.42333 0.20319,0.6096 0.2032,0.18627 0.67734,0.18627 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 211.31934,210.93547 q 0,0.40639 -0.0508,0.84666 h -6.55319 q 0.0677,0.88053 0.5588,1.35466 0.508,0.4572 1.23613,0.4572 1.08373,0 1.50706,-0.91439 h 3.08186 q -0.23706,0.93133 -0.86359,1.67639 -0.6096,0.74507 -1.54093,1.1684 -0.93134,0.42333 -2.0828,0.42333 -1.38853,0 -2.47226,-0.59266 -1.08373,-0.59267 -1.69333,-1.69333 -0.6096,-1.10067 -0.6096,-2.57386 0,-1.4732 0.59266,-2.57387 0.6096,-1.10066 1.69333,-1.69333 1.08374,-0.59266 2.4892,-0.59266 1.3716,0 2.43839,0.57573 1.0668,0.57573 1.65947,1.64253 0.6096,1.0668 0.6096,2.4892 z m -2.96333,-0.762 q 0,-0.74507 -0.508,-1.18533 -0.508,-0.44027 -1.27,-0.44027 -0.72813,0 -1.23613,0.42333 -0.49106,0.42334 -0.6096,1.20227 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 225.4925,207.75201 q 0,1.03293 -0.47414,1.89652 -0.47413,0.84667 -1.45626,1.3716 -0.98213,0.52493 -2.4384,0.52493 h -1.79493 v 4.2672 h -2.89559 v -11.88718 h 4.69052 q 1.4224,0 2.40453,0.49106 0.98213,0.49107 1.4732,1.35467 0.49107,0.8636 0.49107,1.9812 z m -4.58893,1.49013 q 0.82973,0 1.23613,-0.38947 0.4064,-0.38947 0.4064,-1.10066 0,-0.7112 -0.4064,-1.10067 -0.4064,-0.38947 -1.23613,-0.38947 h -1.5748 v 2.98027 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 226.4238,211.07093 q 0,-1.45626 0.54187,-2.55693 0.5588,-1.10066 1.50706,-1.69333 0.94827,-0.59266 2.11666,-0.59266 0.99907,0 1.74413,0.4064 0.762,0.4064 1.1684,1.0668 v -1.33774 h 2.89559 v 9.44879 h -2.89559 v -1.33773 q -0.42333,0.66039 -1.18533,1.06679 -0.74507,0.4064 -1.74413,0.4064 -1.15146,0 -2.09973,-0.59266 -0.94826,-0.6096 -1.50706,-1.71027 -0.54187,-1.11759 -0.54187,-2.57386 z m 7.07812,0.0169 q 0,-1.08374 -0.6096,-1.71027 -0.59266,-0.62653 -1.45626,-0.62653 -0.8636,0 -1.4732,0.62653 -0.59266,0.6096 -0.59266,1.69333 0,1.08373 0.59266,1.7272 0.6096,0.62653 1.4732,0.62653 0.8636,0 1.45626,-0.62653 0.6096,-0.62653 0.6096,-1.71026 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 241.39282,207.70121 q 0.42334,-0.6604 1.1684,-1.0668 0.74507,-0.4064 1.74413,-0.4064 1.1684,0 2.11666,0.59266 0.94827,0.59267 1.49013,1.69333 0.5588,1.10067 0.5588,2.55693 0,1.45627 -0.5588,2.57386 -0.54186,1.10067 -1.49013,1.71027 -0.94826,0.59266 -2.11666,0.59266 -0.98213,0 -1.74413,-0.4064 -0.74506,-0.4064 -1.1684,-1.04986 v 5.82505 h -2.89559 v -13.95304 h 2.89559 z m 4.13173,3.36972 q 0,-1.08373 -0.6096,-1.69333 -0.59267,-0.62653 -1.4732,-0.62653 -0.8636,0 -1.47319,0.62653 -0.59267,0.62653 -0.59267,1.71027 0,1.08373 0.59267,1.71026 0.60959,0.62653 1.47319,0.62653 0.8636,0 1.4732,-0.62653 0.6096,-0.64347 0.6096,-1.7272 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 258.90184,210.93547 q 0,0.40639 -0.0508,0.84666 h -6.55319 q 0.0677,0.88053 0.5588,1.35466 0.508,0.4572 1.23613,0.4572 1.08374,0 1.50707,-0.91439 h 3.08186 q -0.23707,0.93133 -0.8636,1.67639 -0.6096,0.74507 -1.54093,1.1684 -0.93133,0.42333 -2.0828,0.42333 -1.38853,0 -2.47226,-0.59266 -1.08373,-0.59267 -1.69333,-1.69333 -0.6096,-1.10067 -0.6096,-2.57386 0,-1.4732 0.59267,-2.57387 0.6096,-1.10066 1.69333,-1.69333 1.08373,-0.59266 2.48919,-0.59266 1.3716,0 2.4384,0.57573 1.0668,0.57573 1.65946,1.64253 0.6096,1.0668 0.6096,2.4892 z m -2.96333,-0.762 q 0,-0.74507 -0.508,-1.18533 -0.50799,-0.44027 -1.26999,-0.44027 -0.72813,0 -1.23613,0.42333 -0.49107,0.42334 -0.6096,1.20227 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 263.32141,207.93827 q 0.508,-0.77893 1.27,-1.2192 0.762,-0.4572 1.69333,-0.4572 v 3.06493 h -0.79587 q -1.08373,0 -1.62559,0.47413 -0.54187,0.4572 -0.54187,1.6256 v 4.38573 h -2.89559 v -9.44879 h 2.89559 z",
    style: {
      strokeWidth: 0.0700043
    },
    id: "path967"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentWhitepaper);
export default __webpack_public_path__ + "static/media/document-whitepaper.d03beb407981f8d9cecb3d115f6a21a9.svg";
export { ForwardRef as ReactComponent };